module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#youtube",
      toString: function () {
        return this.url;
      }
    }